import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from 'i18next'; // Import de i18n pour gérer la langue

// Création du contexte
const AuthContext = createContext();

// Fournisseur d'authentification
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({
    isAuthenticated: false,
    userId: null,
    communityId: null,
    userRole: null,
    token: null,
    language: 'en', // Langue par défaut
  });
  const [loading, setLoading] = useState(true); // Indique que les données utilisateur sont en cours de chargement

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      const now = new Date().getTime();
      if (userData.expiresAt && userData.expiresAt > now) {
        setUser(userData);
        i18n.changeLanguage(userData.language || 'en'); // Initialiser i18n avec la langue de l'utilisateur
      } else {
        localStorage.removeItem('user'); // Supprimer si expiré
      }
    }
    setLoading(false); // Fin du chargement
  }, []);

  const login = async (userData) => {
    const expiresAt = new Date().getTime() + 60 * 60 * 1000; // Expire dans 1 heure
    const userToStore = {
      isAuthenticated: true,
      userId: userData.userId,
      communityId: userData.communityId,
      expiresAt,
      userRole: userData.userRole,
      token: userData.token,
      language: userData.language || 'en', // Définit la langue de l'utilisateur
    };
  
    localStorage.setItem("user", JSON.stringify(userToStore)); // Stockage dans le localStorage
    setUser(userToStore); // Mettre à jour l'état React
    i18n.changeLanguage(userToStore.language); // Changer la langue dans i18n
    return userToStore; // Retourner immédiatement l'objet
  };  

  // Fonction pour mettre à jour la langue de l'utilisateur
  const updateLanguage = (newLanguage) => {
    setUser((prevState) => {
      const updatedUser = { ...prevState, language: newLanguage };
      localStorage.setItem("user", JSON.stringify(updatedUser)); // Mettre à jour localStorage
      i18n.changeLanguage(newLanguage); // Changer la langue dans i18n
      return updatedUser;
    });
  };

  const isTokenExpired = () => {
    if (!user || !user.expiresAt) return true;
    const now = new Date().getTime();
    return user.expiresAt < now;
  };

  // Fonction pour se déconnecter
  const logout = () => {
    setUser({
      isAuthenticated: false,
      userId: null,
      communityId: null,
      userRole: null,
      token: null,
      language: 'en', // Réinitialiser la langue
    });
    localStorage.removeItem('user');
    i18n.changeLanguage('en'); // Remettre la langue par défaut
  };
  
  if (loading) {
    return <div>Chargement...</div>; // Optionnel : affichage temporaire
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, updateLanguage, isTokenExpired }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useAuth = () => useContext(AuthContext);